import { render, staticRenderFns } from "./LeaveManageAdmin.vue?vue&type=template&id=4d239bc4"
import script from "./LeaveManageAdmin.ts?vue&type=script&lang=ts&external"
export * from "./LeaveManageAdmin.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports